
//
// Mailchimp Campaign Screen Controller
//
// Mainly concerned with fetching extra data via ajax and populating bits of the readout.
//

module.exports = function CampaignController ($page, $$) {

  // Dom
  var $enabled       = $$('[data-should-fetch-voucher-stats]');
  var $requestUrl    = $$('[data-stats-request-url]');
  var $generateForm  = $$('[data-generate-form]');

  // Widgets
  var noticeWidgets = $('[data-widget="ajax-pending-notice"]').toArray().map(getWidgetAtDom);

  // Config
  var shouldFetchStats = $enabled.data('should-fetch-voucher-stats');
  var requestUrl       = $requestUrl.data('stats-request-url');

  // Functions
  function fetchVoucherStats () {
    log('CampaignController::fetch - fetching voucher stats from server...');

    fetchJson(requestUrl, function onJsonStatsAvailable (stats) {
      log('CampaignController::fetch - done', stats);

      // Special actions: show voucher generation form
      if (stats.num_missing_vouchers > 0) {
        $generateForm.show();
        var $buttonBody = $generateForm.find('.button');
        $buttonBody.text( pluraliseBody($buttonBody.text().trim(), stats.num_missing_vouchers) );
      }

      // Proxy results to widgets
      noticeWidgets.map(function (it) {
        if (stats.num_missing_vouchers > 0) {
          it.showNegative(stats.num_missing_vouchers);
        } else {
          it.showPositive(stats.num_missing_vouchers);
        }
      });
    }, function (err) {
      noticeWidgets.map(function (it) {
        it.showErrorMessage(err);
      });
    });
  }

  // Init
  if (shouldFetchStats) fetchVoucherStats();

}

